export const General = {
    acceptTermsAndConditionsLabel: 'accept_terms_conditions',
    addAddressToAccountLabel: 'add_address_to_account',
    allLabel: 'all',
    and: 'and',
    application: 'application',
    applyGiftCard: 'apply_gift_card',
    applyLabel: 'apply',
    browseLabel: 'browse',
    californiaPersonalInformationLabel: 'california_personal_information',
    callUsAriaLabel: 'call_us',
    callUsLabel: 'call_us',
    cancelLabel: 'cancel',
    checkBalance: 'check_balance',
    clearAll: 'clear_all',
    clickingPay: 'clicking_pay',
    closeLabel: 'close',
    commonPrivacyNoticeLabel: 'common_data_privacy_notice',
    confirmLabel: 'confirm',
    contactEmailAriaLabel: 'contact_email',
    contactEmailLabel: 'contact_email',
    contactLabel: 'contact',
    dateLabel: 'date',
    daysLabel: 'days',
    defaultLabel: 'default',
    deleteLabel: 'delete',
    editLabel: 'edit',
    emailShareLabel: 'email_share',
    feet: 'feet',
    freeLabel: 'free',
    amountLabel: 'amount',
    amountAppliedLabel: 'amount_applied',
    giftCardLabel: 'gift_card',
    friday: 'friday',
    helpfulLinksTitle: 'helpful_links',
    homeLabel: 'home',
    itemLabel: 'item',
    kilometers: 'kilometers',
    learnMore: 'learn_more',
    lesson: 'lesson',
    liveChatAriaLabel: 'live_chat',
    liveChatLabel: 'live_chat',
    loadingLabel: 'loading',
    makeDefaultLabel: 'make_default',
    mediumLabel: 'medium',
    meters: 'meters',
    miles: 'miles',
    min: 'min',
    monday: 'monday',
    moreLabel: 'more',
    nextLabel: 'next',
    noLabel: 'no',
    okLabel: 'ok',
    openLabel: 'open',
    or: 'or',
    photoLabel: 'photo',
    previewLabel: 'preview',
    previousLabel: 'previous',
    readMore: 'read_more',
    readLess: 'read_less',
    receiveLabel: 'receive',
    removeLabel: 'remove',
    retryLabel: 'retry',
    reviewPrivacyNoticeLabel: 'review_privacy_notice',
    rewardPointLabel: 'reward_point',
    saturday: 'saturday',
    saveLabel: 'save',
    seeMore: 'see_more',
    selected: 'selected',
    selectLabel: 'select',
    shareLabel: 'share',
    strengthLabel: 'strength',
    strongLabel: 'strong',
    submitLabel: 'submit',
    sunday: 'sunday',
    thursday: 'thursday',
    tuesday: 'tuesday',
    unspecifiedLabel: 'unspecified',
    uploadLabel: 'upload',
    weakLabel: 'weak',
    wednesday: 'wednesday',
    yesLabel: 'yes',
    welcomeLabel: 'welcome',
    wellNotedLabel: 'well_noted'
};
